import * as I18n from 'circe/I18n';
import { setAvailability } from 'domain/operations/drivers/apis';
import { show as showNotification } from 'circe/notifications/actions';
import {
  driverMadeAvailable,
  driverMadeUnavailable,
} from 'domain/operations/accountManagement/actions';
import { DRIVER_STATUS } from './constants';

export const isActive = (status) => DRIVER_STATUS.ACTIVE === status;

export const canChat = (status) => isActive(status);

export const isDeactivated = (status) =>
  DRIVER_STATUS.SUSPENDED === status ||
  DRIVER_STATUS.PENDING_ACTIVATION === status ||
  DRIVER_STATUS.PENDING_USER_ACTION === status;

export const canEdit = (currentId, userId, isBusinessAdmin) =>
  currentId === userId || isBusinessAdmin;

export const isPendingUserAction = (status) => DRIVER_STATUS.PENDING_USER_ACTION === status;

export const filterVehicleTypes = (vehicleTypes) =>
  vehicleTypes
    .filter((vehicleType) => {
      if (vehicleType.type) {
        return true;
      }

      return false;
    })
    .map((vehicleType) => ({
      value: vehicleType.type,
      label: vehicleType.label,
    }));

export const changeAvailability = async (driverStatus, id, setDriverStatus, dispatch) => {
  let availability = driverStatus[id].available;
  if (availability) {
    setDriverStatus({
      ...driverStatus,
      [id]: {
        ...driverStatus[id],
        available: false,
      },
    });
    availability = await setAvailableityFunc(id, false, dispatch);
  } else {
    setDriverStatus({
      ...driverStatus,
      [id]: {
        ...driverStatus[id],
        available: true,
      },
    });
    availability = await setAvailableityFunc(id, true, dispatch);
  }
  setDriverStatus({
    ...driverStatus,
    [id]: {
      ...driverStatus[id],
      available: availability,
    },
  });
};

const setAvailableityFunc = async (id, availability, dispatch) => {
  const response = await setAvailability(id, availability);
  if (response) {
    if (availability) {
      dispatch(driverMadeAvailable(id));
    } else {
      dispatch(driverMadeUnavailable(id));
    }
    return availability;
  }
  window.store.dispatch(
    showNotification(
      I18n.str('error', 'Something Went Wrong, Please try again'),

      'error',
    ),
  );

  return !availability;
};

export const isIdNumber = (value) =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? I18n.str('isIdNumberValidation', 'Invalid Id Number, must be 10 digits')
    : undefined;

export const prepareFileData = async (filesInfo) => {
  try {
    const uploadedFileUrl = filesInfo?.[0]?.uploadedFileUrl;
    if (!uploadedFileUrl) {
      throw new Error('Uploaded file URL is missing.');
    }
    const batchDriversIndex = uploadedFileUrl.indexOf('/batch-drivers/');
    if (batchDriversIndex !== -1) {
      const fileNameWithoutExtension = uploadedFileUrl.substring(
        batchDriversIndex + '/batch-drivers/'.length,
      );
      const fileName = `${fileNameWithoutExtension}`;
      return { fileName };
    } else {
      console.error("'/batch-drivers/' not found in the URL.");
      throw new Error('Failed to prepare file data.');
    }
  } catch (error) {
    console.error('Error preparing file data:', error.message);
    throw new Error('Failed to prepare file data.');
  }
};
